import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigSlackSettings } from "./app-settings-config-slack";

export interface IConfigSlackInputState {
  showModal: boolean;
  editingSlackId: string;
}

export interface IConfigSlackInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigSlackInput extends PureComponent<IConfigSlackInputProps, IConfigSlackInputState> {
  formInputName: string[] = ["apiConfig", "slackSettingsId"];

  constructor(props: IConfigSlackInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingSlackId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingSlackId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingSlackId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigSlackSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingSlackId={this.state.editingSlackId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Slack"
          formInputName={this.formInputName}
          options={this.props.commonSettings.slackSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_slack"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpSlackDropdown"
          addNewTestId="appSettingsMcpSlackAddNewButton"
          editTestId="appSettingsMcpSlackEditButton"
        />
      </>
    );
  }
}
